import {
  TextInput,
  PasswordInput,
  Checkbox,
  Anchor,
  Paper,
  Title,
  Text,
  Container,
  Group,
  Button,
  Flex,
  Alert,
  Grid,
  Box,
  Image,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconAlertCircle } from '@tabler/icons';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { api_login } from '../../services/auth.service';
import { api } from '../../services/master.service';
import { showErrorToast, showSuccessToast } from '../../utilities/Toast';
import Shopping from '../../static/images/shopping.svg';
import { useMediaQuery } from '@mantine/hooks';
import { is_mobile_view } from '../../config';
import { IconX } from '@tabler/icons';
// import { useLocation } from "react-router-dom";


export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  const login_view = is_mobile_view && !isMobileScreen;
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;

  // Starts : States
  const [loading, setLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState('');
  const [checked, setChecked] = useState(false);
  // ENDS : States

  //   const handleMobileChange = async (e) => {
  //   const mobile = e.target.value;
  //   registerForm.setFieldValue('mobile', mobile);

  //   if (mobile.length === 10) { // only check after 10 digits
  //     try {
  //       const res = await api.edit_user({}, { params: { mobile_number: mobile } });
  //       const data = res.data;

  //       if (data.exists && !data.has_email) {
  //         // 🔥 Existing user without email — switch to update mode
  //         setIsUpdateMode(true);
  //         setIsRegister(true);
  //         showSuccessToast({
  //           title: "Existing User",
  //           message: "Account found without email. Please update your email to continue.",
  //         });

  //         registerForm.setValues({
  //           first_name: data.user.first_name || "",
  //           mobile: data.user.username,
  //           email: "",
  //           password: "",
  //           confirm_password: "",
  //         });

  //         // store user_id for update flow
  //         navigate("/login", {
  //           state: {
  //             redirectRegister: true,
  //             user_id: data.user.id,
  //             first_name: data.user.first_name,
  //             mobile: data.user.username,
  //           },
  //         });
  //       }
  //     } catch (err) {
  //       console.log("Check user failed", err);
  //     }
  //   }
  // };


  const form = useForm({
    initialValues: {
      username: '',
      password: '',
    },

    validate: {
      username: (value) => (value ? null : 'Username is required'),
      password: (value) => (value ? null : 'Password is required'),
    },
  });

  useEffect(() => {
    if (location.state?.redirectRegister) {
      setIsRegister(true);
      setIsUpdateMode(true);
      // Prefill register form with known user details
      registerForm.setValues({
        first_name: location.state.first_name || "",
        mobile: location.state.mobile || "",
        email: "",
        password: "",
        confirm_password: "",
      });
    }
  }, [location.state]);


  const registerForm = useForm({
    initialValues: {
      mobile: '',
      password: '',
      confirm_password: '',
      first_name: '',
      email: '',
      referral_code: "",
    },
    validate: {
      first_name: (value) => (value ? null : 'First name is required'),
      email: (value) => (value ? null : 'Email is required'),
      mobile: (value) => (value ? null : 'Phone No. is required'),
      password: (value) => (value ? null : 'Password is required'),
      confirm_password: (value, values) =>
        value !== values.password ? 'Passwords did not match' : null,
    },
  });

  const doLogin = async () => {
    setLoading(true);
    console.log(form.values);
    await api_login({
      ...form.values,
      role: 'customer',
    })
      .then((res) => {
        setLoading(false);
        console.log(res);
        if (res.success) {
          localStorage.setItem('user_token', res.token);
          localStorage.setItem('user', JSON.stringify(res.user));

          if (res.user && res.user.first_name) {
            localStorage.setItem('user_first_name', res.user.first_name);
          }
          navigate('/');
        } else {
          setLoginError(true);
          setLoginErrorMessage(res.message);
        }
      })
      .catch((err) => {
        setLoginError(true);
        setLoginErrorMessage(err.message);
        setLoading(false);
      });
    setLoading(false);
  };

  // const doRegister = async () => {
  //   setLoading(true);
  //   console.log(registerForm.values);
  //   await api
  //     .register({
  //       ...registerForm.values,
  //       role: 'customer',
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       console.log(res.data);
  //       if (res.data.success) {
  //         // navigate('/');
  //         showSuccessToast({ title: 'Success', message: res.data.message });
  //       } else {
  //         showErrorToast({ title: 'Error', message: res.data.message });
  //       }
  //     })
  //     .catch((err) => {
  //       showErrorToast({ title: 'Error', message: err.message });
  //     });
  //   setLoading(false);
  // };

  const doRegister = async () => {
    setLoading(true);

    const payload = {
      ...registerForm.values,
      role: 'customer',
      counter_id: localStorage.getItem('counter_id'),
      user_id: location.state?.user_id,
    };

    try {
      if (isUpdateMode && location.state?.user_id) {
        // ✅ Use your existing service
        const res = await api.edit_user(payload);

        if (res.data?.success) {
          showSuccessToast({
            title: "Success",
            message: "Email updated successfully. Please verify your email and login again.",
          });
          navigate('/login');
        } else {
          showErrorToast({
            title: "Error",
            message: res.data?.message || "Unable to update email.",
          });
        }

      } else {
        // ✅ Normal registration flow
        const res = await api.register(payload);

        if (res.data?.success) {
          showSuccessToast({
            title: "Success",
            message: res.data?.message || "Registration successful.",
          });
        } else {
          showErrorToast({
            title: "Error",
            message: res.data?.message || "Registration failed.",
          });
        }
      }
    } catch (err) {
      showErrorToast({
        title: "Error",
        message: err.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Box
        px={isMobileScreen ? 14 : 30}
        style={{ overflow: 'hidden', marginTop: isMobileScreen ? '150px' : '170px', position: 'relative', }}
        w={'100%'}
      >

        <Container size={'xl'} mt={isMobileScreen ? 10 : 50} mb={100} w={'100%'}>
          <Flex align={'center'} justify={'center'} w={'100%'}>
            <Grid gutter={'lg'} w={'100%'}>
              {isMobileScreen && !login_view ? (
                <></>
              ) : (
                <Grid.Col span={8}>
                  <Flex align={'center'} justify={'center'} h={'100%'}>
                    <Image src={Shopping} alt="" width={400} />
                  </Flex>
                </Grid.Col>
              )}
              {!isRegister ? (
                <Grid.Col span={12} md={4} lg={4}>
                  <form onSubmit={form.onSubmit(doLogin)}>
                    <Text size={'xs'}> Welcome, </Text>
                    <Text fw={600} size="xl">
                      Login to Quzone.
                    </Text>

                    {loginError ? (
                      <Alert
                        mt={20}
                        icon={<IconAlertCircle size={16} />}
                        title="Error!"
                        color="red"
                      >
                        {loginErrorMessage}
                      </Alert>
                    ) : (
                      ''
                    )}




                    <Paper withBorder shadow="md" p={30} mt={20} radius="md">
                      <TextInput
                        label="Phone Number (Username)"
                        placeholder="Enter Your Phone No."
                        {...form.getInputProps('username')}
                      />
                      <PasswordInput
                        label="Password"
                        placeholder="Enter Your password"
                        mt="md"
                        {...form.getInputProps('password')}
                      />
                      <Group position="apart" mt="lg">
                        <Anchor
                          onClick={(event) => {
                            event.preventDefault();
                            navigate('/forget');
                          }}
                          href="#"
                          size="sm"
                        >
                          Forgot password?
                        </Anchor>
                      </Group>
                      <Group grow mt="xl">
                        <Button loading={loading} type="submit" radius="xl">
                          Sign in
                        </Button>

                        <Button
                          variant="filled"
                          color="red.6"
                          radius="xl"
                          style={{
                            fontWeight: 600,
                            letterSpacing: '0.3px',
                            //  boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
                          }}
                          onClick={() => navigate('/')}
                        >
                          Exit
                        </Button>
                      </Group>
                    </Paper>
                  </form>

                  <Text fz={'md'} fw={500} mt={10}>
                    Don't Have an account ?{' '}
                    <a
                      style={{ textDecorationLine: 'underline', cursor: 'pointer' }}
                      color={'green'}
                      onClick={() => setIsRegister(true)}
                    >
                      Register
                    </a>
                  </Text>
                </Grid.Col>
              ) : (
                <Grid.Col span={12} md={4} lg={4}>
                  <form
                    onSubmit={registerForm.onSubmit((values) => {
                      if (checked) {
                        doRegister();
                      }
                    })}
                    onError={(err) => {
                      console.log(err);
                    }}
                  >
                    <Text size={'xs'}> New to quzone ? </Text>
                    <Text fw={600} size="xl">
                      Register Now.
                    </Text>

                    <Paper withBorder shadow="md" p={30} mt={20} radius="md">
                      <TextInput
                        label="First Name"
                        placeholder="Enter Your first name"
                        {...registerForm.getInputProps('first_name')}
                      />
                      <TextInput
                        label="Email Address"
                        placeholder="Enter Your email address"
                        mt="md"
                        {...registerForm.getInputProps('email')}
                      />
                      <TextInput
                        type="text"
                        label="Phone Number (Username)"
                        placeholder="Enter Your phone no."
                        mt="md"
                        {...registerForm.getInputProps("mobile")}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, ""); // allow only numbers
                        }}
                        onBlur={async (e) => {
                          const value = e.target.value.trim();
                          if (!value) return;

                          try {
                            const res = await api.check_mobile_exists(value);
                            const data = res.data;

                            console.log("📞 Mobile check response:", data);

                            if (data.exists && !data.has_email) {
                              // ✅ Existing user but no email — switch to update flow
                              showSuccessToast({
                                title: "User Found",
                                message: "This number exists but no email found. Switching to update mode.",
                              });

                              setIsRegister(true);
                              setIsUpdateMode(true);

                              registerForm.setValues({
                                mobile: value,
                                first_name: data.user?.first_name || "",
                                email: "",
                                password: "",
                                confirm_password: "",
                              });

                              // Store user_id for update call
                              location.state = {
                                user_id: data.user?.id,
                                first_name: data.user?.first_name,
                                mobile: value,
                                redirectRegister: true,
                              };
                            } else if (data.exists && data.has_email) {
                              showErrorToast({
                                title: "Already Registered",
                                message: "This number is already registered, Please login.",
                              });
                            } else {
                              showSuccessToast({
                                title: "New User",
                                message: "You can continue with new registration.",
                              });
                            }
                          } catch (err) {
                            console.error("❌ Mobile check error:", err);
                            showErrorToast({
                              title: "Error",
                              message: err.message || "Unable to verify mobile number.",
                            });
                          }
                        }}
                      />
                      <PasswordInput
                        label="Password"
                        placeholder="Enter Your password"
                        mt="md"
                        {...registerForm.getInputProps('password')}
                      />
                      <PasswordInput
                        label="Confirm Password"
                        placeholder="Enter confirm password"
                        mt="md"
                        {...registerForm.getInputProps('confirm_password')}
                      />
                      <Text c="red" fw={500} size="xs" mt="md"  >
                        Note: Do you have any referral?
                      </Text>
                      <TextInput
                        label="Referral Code (Optional)"
                        placeholder="Enter referral code "
                        mt="xs"
                        {...registerForm.getInputProps("referral_code")}
                        onChange={(event) => {
                          const value = event.target.value
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, "");

                          registerForm.setFieldValue("referral_code", value);
                        }}

                      />

                      <Checkbox my={20}
                        label={
                          <>
                            I accept{' '}
                            <Anchor fw={700} href="/terms" target="_blank" inherit>
                              Terms of service
                            </Anchor>
                          </>
                        }
                        checked={checked}
                        onChange={(event) => setChecked(event.currentTarget.checked)}
                      />

                      <Button disabled={!checked} loading={loading} type="submit" fullWidth mt="xl">
                        {isUpdateMode ? "Update" : "Register"}
                      </Button>
                    </Paper>
                  </form>

                  <Text fz={'md'} fw={500} mt={10}>
                    Already Have an account ?{' '}
                    <a
                      style={{ textDecorationLine: 'underline', cursor: 'pointer' }}
                      color={'green'}
                      onClick={() => setIsRegister(false)}
                    >
                      Login
                    </a>
                  </Text>
                </Grid.Col>
              )}
            </Grid>
          </Flex>
        </Container>
      </Box>
    </>
  );
}
